import { render, staticRenderFns } from "./ImprintPage.vue?vue&type=template&id=a8c8d036&"
import script from "./ImprintPage.vue?vue&type=script&lang=js&"
export * from "./ImprintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports